// Translations for PT, EN, ES, FR, DE
export const translations = {
  pt: {
    // Beta Banner
    beta: {
      badge: "BETA",
      banner: "Plataforma em fase Beta — em constante desenvolvimento e melhoria contínua."
    },
    
    // Navigation
    nav: {
      about: "Sobre",
      platform: "Plataforma",
      coverage: "Cobertura",
      roadmap: "Roadmap",
      requestDemo: "Aceder à Plataforma"
    },
    
    // Roadmap Page
    roadmap: {
      overline: "DESENVOLVIMENTO",
      title: "Roadmap & Changelog",
      subtitle: "Acompanhe o progresso do desenvolvimento da plataforma AzorPort",
      backToHome: "Voltar ao Início",
      sections: {
        completed: "Concluído",
        inProgress: "Em Desenvolvimento",
        planned: "Planeado"
      },
      phases: {
        phase1: {
          title: "Fase 1 — Fundação",
          status: "completed",
          items: [
            "Sistema de autenticação e gestão de utilizadores",
            "Dashboard principal com visão geral das operações",
            "Integração com base de dados MongoDB",
            "Interface responsiva para desktop e mobile"
          ]
        },
        phase2: {
          title: "Fase 2 — Operações Core",
          status: "inProgress",
          items: [
            "Monitorização de voos em tempo real",
            "Sistema de gestão de slots aeroportuários",
            "Alertas e notificações automáticas",
            "Relatórios operacionais básicos"
          ]
        },
        phase3: {
          title: "Fase 3 — Integração Avançada",
          status: "planned",
          items: [
            "Integração com EUROCONTROL",
            "API pública para parceiros",
            "Sistema de previsão meteorológica",
            "Módulo de manutenção preditiva"
          ]
        },
        phase4: {
          title: "Fase 4 — Expansão",
          status: "planned",
          items: [
            "Aplicação móvel nativa",
            "Integração com sistemas de reservas",
            "Analytics avançados com IA",
            "Suporte multi-tenant"
          ]
        }
      },
      changelog: {
        title: "Changelog Recente",
        entries: [
          { version: "0.3.0", date: "Dez 2025", changes: "Landing page multi-idioma, formulário de contacto com emails" },
          { version: "0.2.0", date: "Nov 2025", changes: "Dashboard de operações, sistema de alertas básico" },
          { version: "0.1.0", date: "Out 2025", changes: "Lançamento inicial da versão Beta" }
        ]
      }
    },
    
    // Hero Section
    hero: {
      overline: "PLATAFORMA EMPRESARIAL",
      title: "Gestão de Aviação de Precisão para os Açores",
      description: "Uma plataforma centralizada que conecta e otimiza as operações dos 9 aeroportos do arquipélago açoriano, garantindo eficiência e segurança em cada voo.",
      ctaPrimary: "Aceder à Plataforma",
      ctaSecondary: "Explorar Funcionalidades",
      stats: {
        airports: "Aeroportos",
        monitoring: "Monitorização",
        integration: "Integração"
      }
    },
    
    // About Section
    about: {
      overline: "SOBRE A AZORPORT",
      title: "Conectando o Arquipélago Através da Inovação",
      paragraph1: "O AzorPort nasceu da necessidade de unificar e modernizar a gestão aeroportuária nos Açores. Com 9 ilhas e 9 aeroportos, o desafio de manter operações coordenadas e eficientes exigia uma solução à altura.",
      paragraph2: "A nossa plataforma centraliza todas as operações, desde o controlo de tráfego aéreo até à gestão de manutenção, passando pela coordenação de recursos humanos e logística de ground handling.",
      paragraph3: "Com tecnologia de ponta e uma equipa dedicada, garantimos que cada voo que aterra ou descola nos Açores está suportado por um sistema robusto, seguro e preparado para o futuro da aviação.",
      founded: "Fundação",
      islandsServed: "Ilhas Servidas",
      platformLabel: "Plataforma"
    },
    
    // Features Section
    features: {
      overline: "PLATAFORMA",
      title: "Funcionalidades de Classe Mundial",
      description: "Uma suite completa de ferramentas para gestão aeroportuária moderna e eficiente.",
      items: {
        radar: {
          title: "Monitorização em Tempo Real",
          description: "Sistema de radar integrado que acompanha todos os voos no espaço aéreo açoriano. Visualize posições de aeronaves, condições meteorológicas, alertas de proximidade e dados de telemetria em tempo real. Dashboard interativo com filtros por aeroporto, companhia aérea e tipo de aeronave."
        },
        traffic: {
          title: "Gestão de Tráfego Aéreo",
          description: "Coordenação inteligente do espaço aéreo dos Açores com gestão de slots, sequenciamento de aproximações e partidas, e comunicação integrada entre torres de controlo. Otimização automática de rotas para minimizar atrasos e consumo de combustível."
        },
        maintenance: {
          title: "Manutenção de Frota",
          description: "Gestão completa do ciclo de vida das aeronaves com calendário de inspeções, histórico de manutenções, controlo de peças e certificações. Alertas automáticos para revisões obrigatórias e integração com fabricantes para atualizações técnicas."
        },
        operations: {
          title: "Operações 24/7",
          description: "Centro de operações com monitorização contínua de todos os aeroportos. Gestão de equipas de ground handling, coordenação de combustível, catering e bagagens. Suporte técnico dedicado disponível a qualquer hora com resposta em menos de 15 minutos."
        },
        security: {
          title: "Segurança Avançada",
          description: "Protocolos de segurança certificados pela EASA e ICAO. Sistema de controlo de acesso biométrico, videovigilância com IA para deteção de anomalias, gestão de credenciais de pessoal e rastreamento de bagagens em tempo real."
        },
        connectivity: {
          title: "Conectividade Global",
          description: "Integração total com sistemas EUROCONTROL, SITA e principais GDS mundiais. Partilha de dados em tempo real com companhias aéreas, autoridades de aviação civil e parceiros de handling. APIs abertas para integração com sistemas externos."
        }
      },
      uptime: "Uptime garantido"
    },
    
    // Coverage Section
    coverage: {
      overline: "COBERTURA",
      title: "9 Ilhas, 9 Aeroportos, 1 Sistema",
      description: "Cobertura completa de todo o arquipélago dos Açores, garantindo conectividade e eficiência em cada ilha.",
      location: "Arquipélago dos Açores, Portugal"
    },
    
    // Contact Section
    contact: {
      overline: "CONTACTO",
      title: "Pronto para Transformar as Suas Operações?",
      description: "Entre em contacto connosco para agendar uma demonstração personalizada e descobrir como o AzorPort pode revolucionar a gestão aeroportuária na sua organização.",
      email: "Email",
      location: "Localização",
      locationValue: "Vila do Corvo, Açores, Portugal",
      form: {
        title: "Solicitar Demonstração",
        name: "Nome",
        namePlaceholder: "O seu nome",
        emailLabel: "Email",
        emailPlaceholder: "email@exemplo.com",
        company: "Empresa",
        companyPlaceholder: "Nome da empresa",
        message: "Mensagem",
        messagePlaceholder: "Como podemos ajudar?",
        submit: "Enviar Mensagem",
        submitting: "A enviar..."
      },
      toast: {
        success: "Mensagem enviada com sucesso!",
        successDescription: "Entraremos em contacto brevemente."
      }
    },
    
    // Footer
    footer: {
      description: "Plataforma de Gestão de Aviação para os Açores. Conectando ilhas, otimizando operações.",
      navigation: "Navegação",
      airports: "Aeroportos",
      copyright: "© 2026 AzorPort | Aviation Management Platform",
      createdBy: "Criado por Diogo Ribeiro"
    }
  },
  
  en: {
    // Navigation
    nav: {
      about: "About",
      platform: "Platform",
      coverage: "Coverage",
      roadmap: "Roadmap",
      requestDemo: "Access Platform"
    },
    
    // Roadmap Page
    roadmap: {
      overline: "DEVELOPMENT",
      title: "Roadmap & Changelog",
      subtitle: "Track the development progress of the AzorPort platform",
      backToHome: "Back to Home",
      sections: {
        completed: "Completed",
        inProgress: "In Progress",
        planned: "Planned"
      },
      phases: {
        phase1: {
          title: "Phase 1 — Foundation",
          status: "completed",
          items: [
            "Authentication system and user management",
            "Main dashboard with operations overview",
            "MongoDB database integration",
            "Responsive interface for desktop and mobile"
          ]
        },
        phase2: {
          title: "Phase 2 — Core Operations",
          status: "inProgress",
          items: [
            "Real-time flight monitoring",
            "Airport slot management system",
            "Automatic alerts and notifications",
            "Basic operational reports"
          ]
        },
        phase3: {
          title: "Phase 3 — Advanced Integration",
          status: "planned",
          items: [
            "EUROCONTROL integration",
            "Public API for partners",
            "Weather forecasting system",
            "Predictive maintenance module"
          ]
        },
        phase4: {
          title: "Phase 4 — Expansion",
          status: "planned",
          items: [
            "Native mobile application",
            "Booking system integration",
            "Advanced AI-powered analytics",
            "Multi-tenant support"
          ]
        }
      },
      changelog: {
        title: "Recent Changelog",
        entries: [
          { version: "0.3.0", date: "Dec 2025", changes: "Multi-language landing page, contact form with emails" },
          { version: "0.2.0", date: "Nov 2025", changes: "Operations dashboard, basic alert system" },
          { version: "0.1.0", date: "Oct 2025", changes: "Initial Beta release" }
        ]
      }
    },

    // Hero Section
    hero: {
      overline: "ENTERPRISE PLATFORM",
      title: "Precision Aviation Management for the Azores",
      description: "A centralized platform that connects and optimizes operations across 9 airports in the Azorean archipelago, ensuring efficiency and safety in every flight.",
      ctaPrimary: "Access Platform",
      ctaSecondary: "Explore Features",
      stats: {
        airports: "Airports",
        monitoring: "Monitoring",
        integration: "Integration"
      }
    },
    
    // About Section
    about: {
      overline: "ABOUT AZORPORT",
      title: "Connecting the Archipelago Through Innovation",
      paragraph1: "AzorPort was born from the need to unify and modernize airport management in the Azores. With 9 islands and 9 airports, the challenge of maintaining coordinated and efficient operations required a solution to match.",
      paragraph2: "Our platform centralizes all operations, from air traffic control to maintenance management, including human resources coordination and ground handling logistics.",
      paragraph3: "With cutting-edge technology and a dedicated team, we ensure that every flight landing or taking off in the Azores is supported by a robust, secure system ready for the future of aviation.",
      founded: "Founded",
      islandsServed: "Islands Served",
      platformLabel: "Platform"
    },
    
    // Features Section
    features: {
      overline: "PLATFORM",
      title: "World-Class Features",
      description: "A complete suite of tools for modern and efficient airport management.",
      items: {
        radar: {
          title: "Real-Time Monitoring",
          description: "Integrated radar system tracking all flights in Azorean airspace. View aircraft positions, weather conditions, proximity alerts, and telemetry data in real-time. Interactive dashboard with filters by airport, airline, and aircraft type."
        },
        traffic: {
          title: "Air Traffic Management",
          description: "Intelligent coordination of Azores airspace with slot management, approach and departure sequencing, and integrated communication between control towers. Automatic route optimization to minimize delays and fuel consumption."
        },
        maintenance: {
          title: "Fleet Maintenance",
          description: "Complete aircraft lifecycle management with inspection schedules, maintenance history, parts control, and certifications. Automatic alerts for mandatory reviews and integration with manufacturers for technical updates."
        },
        operations: {
          title: "24/7 Operations",
          description: "Operations center with continuous monitoring of all airports. Ground handling team management, fuel coordination, catering, and baggage. Dedicated technical support available 24/7 with response time under 15 minutes."
        },
        security: {
          title: "Advanced Security",
          description: "EASA and ICAO certified security protocols. Biometric access control system, AI-powered video surveillance for anomaly detection, personnel credential management, and real-time baggage tracking."
        },
        connectivity: {
          title: "Global Connectivity",
          description: "Full integration with EUROCONTROL, SITA, and major global GDS systems. Real-time data sharing with airlines, civil aviation authorities, and handling partners. Open APIs for external system integration."
        }
      },
      uptime: "Guaranteed uptime"
    },
    
    // Coverage Section
    coverage: {
      overline: "COVERAGE",
      title: "9 Islands, 9 Airports, 1 System",
      description: "Complete coverage of the entire Azores archipelago, ensuring connectivity and efficiency on every island.",
      location: "Azores Archipelago, Portugal"
    },
    
    // Contact Section
    contact: {
      overline: "CONTACT",
      title: "Ready to Transform Your Operations?",
      description: "Get in touch with us to schedule a personalized demonstration and discover how AzorPort can revolutionize airport management in your organization.",
      email: "Email",
      location: "Location",
      locationValue: "Vila do Corvo, Azores, Portugal",
      form: {
        title: "Request Demo",
        name: "Name",
        namePlaceholder: "Your name",
        emailLabel: "Email",
        emailPlaceholder: "email@example.com",
        company: "Company",
        companyPlaceholder: "Company name",
        message: "Message",
        messagePlaceholder: "How can we help?",
        submit: "Send Message",
        submitting: "Sending..."
      },
      toast: {
        success: "Message sent successfully!",
        successDescription: "We will contact you shortly."
      }
    },
    
    // Footer
    footer: {
      description: "Aviation Management Platform for the Azores. Connecting islands, optimizing operations.",
      navigation: "Navigation",
      airports: "Airports",
      copyright: "© 2026 AzorPort | Aviation Management Platform",
      createdBy: "Created by Diogo Ribeiro"
    },
    
    // Beta Banner
    beta: {
      badge: "BETA",
      banner: "Platform in Beta phase — under constant development and continuous improvement."
    }
  },

  es: {
    // Navigation
    nav: {
      about: "Acerca de",
      platform: "Plataforma",
      coverage: "Cobertura",
      roadmap: "Roadmap",
      requestDemo: "Acceder a la Plataforma"
    },
    
    // Roadmap Page
    roadmap: {
      overline: "DESARROLLO",
      title: "Roadmap & Changelog",
      subtitle: "Siga el progreso del desarrollo de la plataforma AzorPort",
      backToHome: "Volver al Inicio",
      sections: {
        completed: "Completado",
        inProgress: "En Desarrollo",
        planned: "Planificado"
      },
      phases: {
        phase1: {
          title: "Fase 1 — Fundación",
          status: "completed",
          items: [
            "Sistema de autenticación y gestión de usuarios",
            "Dashboard principal con visión general de operaciones",
            "Integración con base de datos MongoDB",
            "Interfaz responsiva para escritorio y móvil"
          ]
        },
        phase2: {
          title: "Fase 2 — Operaciones Core",
          status: "inProgress",
          items: [
            "Monitorización de vuelos en tiempo real",
            "Sistema de gestión de slots aeroportuarios",
            "Alertas y notificaciones automáticas",
            "Informes operacionales básicos"
          ]
        },
        phase3: {
          title: "Fase 3 — Integración Avanzada",
          status: "planned",
          items: [
            "Integración con EUROCONTROL",
            "API pública para partners",
            "Sistema de previsión meteorológica",
            "Módulo de mantenimiento predictivo"
          ]
        },
        phase4: {
          title: "Fase 4 — Expansión",
          status: "planned",
          items: [
            "Aplicación móvil nativa",
            "Integración con sistemas de reservas",
            "Analytics avanzados con IA",
            "Soporte multi-tenant"
          ]
        }
      },
      changelog: {
        title: "Changelog Reciente",
        entries: [
          { version: "0.3.0", date: "Dic 2025", changes: "Landing page multi-idioma, formulario de contacto con emails" },
          { version: "0.2.0", date: "Nov 2025", changes: "Dashboard de operaciones, sistema de alertas básico" },
          { version: "0.1.0", date: "Oct 2025", changes: "Lanzamiento inicial de la versión Beta" }
        ]
      }
    },

    // Hero Section
    hero: {
      overline: "PLATAFORMA EMPRESARIAL",
      title: "Gestión de Aviación de Precisión para las Azores",
      description: "Una plataforma centralizada que conecta y optimiza las operaciones de los 9 aeropuertos del archipiélago azoriano, garantizando eficiencia y seguridad en cada vuelo.",
      ctaPrimary: "Acceder a la Plataforma",
      ctaSecondary: "Explorar Funciones",
      stats: {
        airports: "Aeropuertos",
        monitoring: "Monitorización",
        integration: "Integración"
      }
    },
    
    // About Section
    about: {
      overline: "SOBRE AZORPORT",
      title: "Conectando el Archipiélago a Través de la Innovación",
      paragraph1: "AzorPort nació de la necesidad de unificar y modernizar la gestión aeroportuaria en las Azores. Con 9 islas y 9 aeropuertos, el desafío de mantener operaciones coordinadas y eficientes exigía una solución a la altura.",
      paragraph2: "Nuestra plataforma centraliza todas las operaciones, desde el control de tráfico aéreo hasta la gestión de mantenimiento, pasando por la coordinación de recursos humanos y logística de ground handling.",
      paragraph3: "Con tecnología de vanguardia y un equipo dedicado, garantizamos que cada vuelo que aterriza o despega en las Azores está respaldado por un sistema robusto, seguro y preparado para el futuro de la aviación.",
      founded: "Fundación",
      islandsServed: "Islas Servidas",
      platformLabel: "Plataforma"
    },
    
    // Features Section
    features: {
      overline: "PLATAFORMA",
      title: "Funcionalidades de Clase Mundial",
      description: "Una suite completa de herramientas para una gestión aeroportuaria moderna y eficiente.",
      items: {
        radar: {
          title: "Monitorización en Tiempo Real",
          description: "Sistema de radar integrado que rastrea todos los vuelos en el espacio aéreo azoriano. Visualice posiciones de aeronaves, condiciones meteorológicas, alertas de proximidad y datos de telemetría en tiempo real. Panel interactivo con filtros por aeropuerto, aerolínea y tipo de aeronave."
        },
        traffic: {
          title: "Gestión de Tráfico Aéreo",
          description: "Coordinación inteligente del espacio aéreo de las Azores con gestión de slots, secuenciación de aproximaciones y salidas, y comunicación integrada entre torres de control. Optimización automática de rutas para minimizar retrasos y consumo de combustible."
        },
        maintenance: {
          title: "Mantenimiento de Flota",
          description: "Gestión completa del ciclo de vida de las aeronaves con calendario de inspecciones, historial de mantenimientos, control de piezas y certificaciones. Alertas automáticas para revisiones obligatorias e integración con fabricantes para actualizaciones técnicas."
        },
        operations: {
          title: "Operaciones 24/7",
          description: "Centro de operaciones con monitorización continua de todos los aeropuertos. Gestión de equipos de ground handling, coordinación de combustible, catering y equipajes. Soporte técnico dedicado disponible las 24 horas con respuesta en menos de 15 minutos."
        },
        security: {
          title: "Seguridad Avanzada",
          description: "Protocolos de seguridad certificados por EASA e ICAO. Sistema de control de acceso biométrico, videovigilancia con IA para detección de anomalías, gestión de credenciales de personal y rastreo de equipajes en tiempo real."
        },
        connectivity: {
          title: "Conectividad Global",
          description: "Integración total con sistemas EUROCONTROL, SITA y principales GDS mundiales. Compartición de datos en tiempo real con aerolíneas, autoridades de aviación civil y partners de handling. APIs abiertas para integración con sistemas externos."
        }
      },
      uptime: "Uptime garantizado"
    },
    
    // Coverage Section
    coverage: {
      overline: "COBERTURA",
      title: "9 Islas, 9 Aeropuertos, 1 Sistema",
      description: "Cobertura completa de todo el archipiélago de las Azores, garantizando conectividad y eficiencia en cada isla.",
      location: "Archipiélago de las Azores, Portugal"
    },
    
    // Contact Section
    contact: {
      overline: "CONTACTO",
      title: "¿Listo para Transformar sus Operaciones?",
      description: "Póngase en contacto con nosotros para programar una demostración personalizada y descubrir cómo AzorPort puede revolucionar la gestión aeroportuaria en su organización.",
      email: "Email",
      location: "Ubicación",
      locationValue: "Vila do Corvo, Azores, Portugal",
      form: {
        title: "Solicitar Demostración",
        name: "Nombre",
        namePlaceholder: "Su nombre",
        emailLabel: "Email",
        emailPlaceholder: "email@ejemplo.com",
        company: "Empresa",
        companyPlaceholder: "Nombre de la empresa",
        message: "Mensaje",
        messagePlaceholder: "¿Cómo podemos ayudar?",
        submit: "Enviar Mensaje",
        submitting: "Enviando..."
      },
      toast: {
        success: "¡Mensaje enviado con éxito!",
        successDescription: "Nos pondremos en contacto en breve."
      }
    },
    
    // Footer
    footer: {
      description: "Plataforma de Gestión de Aviación para las Azores. Conectando islas, optimizando operaciones.",
      navigation: "Navegación",
      airports: "Aeropuertos",
      copyright: "© 2026 AzorPort | Aviation Management Platform",
      createdBy: "Creado por Diogo Ribeiro"
    },
    
    // Beta Banner
    beta: {
      badge: "BETA",
      banner: "Plataforma en fase Beta — en constante desarrollo y mejora continua."
    }
  },

  fr: {
    // Navigation
    nav: {
      about: "À propos",
      platform: "Plateforme",
      coverage: "Couverture",
      roadmap: "Roadmap",
      requestDemo: "Accéder à la Plateforme"
    },
    
    // Roadmap Page
    roadmap: {
      overline: "DÉVELOPPEMENT",
      title: "Roadmap & Changelog",
      subtitle: "Suivez la progression du développement de la plateforme AzorPort",
      backToHome: "Retour à l'Accueil",
      sections: {
        completed: "Terminé",
        inProgress: "En Cours",
        planned: "Planifié"
      },
      phases: {
        phase1: {
          title: "Phase 1 — Fondation",
          status: "completed",
          items: [
            "Système d'authentification et gestion des utilisateurs",
            "Tableau de bord principal avec vue d'ensemble des opérations",
            "Intégration base de données MongoDB",
            "Interface responsive pour desktop et mobile"
          ]
        },
        phase2: {
          title: "Phase 2 — Opérations Core",
          status: "inProgress",
          items: [
            "Surveillance des vols en temps réel",
            "Système de gestion des créneaux aéroportuaires",
            "Alertes et notifications automatiques",
            "Rapports opérationnels de base"
          ]
        },
        phase3: {
          title: "Phase 3 — Intégration Avancée",
          status: "planned",
          items: [
            "Intégration EUROCONTROL",
            "API publique pour partenaires",
            "Système de prévisions météorologiques",
            "Module de maintenance prédictive"
          ]
        },
        phase4: {
          title: "Phase 4 — Expansion",
          status: "planned",
          items: [
            "Application mobile native",
            "Intégration systèmes de réservation",
            "Analytics avancés avec IA",
            "Support multi-tenant"
          ]
        }
      },
      changelog: {
        title: "Changelog Récent",
        entries: [
          { version: "0.3.0", date: "Déc 2025", changes: "Landing page multi-langue, formulaire de contact avec emails" },
          { version: "0.2.0", date: "Nov 2025", changes: "Dashboard des opérations, système d'alertes basique" },
          { version: "0.1.0", date: "Oct 2025", changes: "Lancement initial de la version Bêta" }
        ]
      }
    },

    // Hero Section
    hero: {
      overline: "PLATEFORME ENTREPRISE",
      title: "Gestion de Précision de l'Aviation pour les Açores",
      description: "Une plateforme centralisée qui connecte et optimise les opérations des 9 aéroports de l'archipel açorien, garantissant efficacité et sécurité à chaque vol.",
      ctaPrimary: "Accéder à la Plateforme",
      ctaSecondary: "Explorer les Fonctionnalités",
      stats: {
        airports: "Aéroports",
        monitoring: "Surveillance",
        integration: "Intégration"
      }
    },
    
    // About Section
    about: {
      overline: "À PROPOS D'AZORPORT",
      title: "Connecter l'Archipel par l'Innovation",
      paragraph1: "AzorPort est né du besoin d'unifier et de moderniser la gestion aéroportuaire aux Açores. Avec 9 îles et 9 aéroports, le défi de maintenir des opérations coordonnées et efficaces exigeait une solution à la hauteur.",
      paragraph2: "Notre plateforme centralise toutes les opérations, du contrôle du trafic aérien à la gestion de la maintenance, en passant par la coordination des ressources humaines et la logistique de ground handling.",
      paragraph3: "Avec une technologie de pointe et une équipe dévouée, nous garantissons que chaque vol atterrissant ou décollant aux Açores est soutenu par un système robuste, sécurisé et prêt pour l'avenir de l'aviation.",
      founded: "Fondation",
      islandsServed: "Îles Desservies",
      platformLabel: "Plateforme"
    },
    
    // Features Section
    features: {
      overline: "PLATEFORME",
      title: "Fonctionnalités de Classe Mondiale",
      description: "Une suite complète d'outils pour une gestion aéroportuaire moderne et efficace.",
      items: {
        radar: {
          title: "Surveillance en Temps Réel",
          description: "Système radar intégré suivant tous les vols dans l'espace aérien açorien. Visualisez les positions des aéronefs, les conditions météo, les alertes de proximité et les données de télémétrie en temps réel. Tableau de bord interactif avec filtres par aéroport, compagnie et type d'aéronef."
        },
        traffic: {
          title: "Gestion du Trafic Aérien",
          description: "Coordination intelligente de l'espace aérien des Açores avec gestion des créneaux, séquençage des approches et départs, et communication intégrée entre tours de contrôle. Optimisation automatique des routes pour minimiser retards et consommation de carburant."
        },
        maintenance: {
          title: "Maintenance de Flotte",
          description: "Gestion complète du cycle de vie des aéronefs avec calendrier d'inspections, historique de maintenance, contrôle des pièces et certifications. Alertes automatiques pour révisions obligatoires et intégration avec les constructeurs pour mises à jour techniques."
        },
        operations: {
          title: "Opérations 24/7",
          description: "Centre d'opérations avec surveillance continue de tous les aéroports. Gestion des équipes de handling, coordination carburant, catering et bagages. Support technique dédié disponible 24h/24 avec temps de réponse inférieur à 15 minutes."
        },
        security: {
          title: "Sécurité Avancée",
          description: "Protocoles de sécurité certifiés EASA et OACI. Système de contrôle d'accès biométrique, vidéosurveillance avec IA pour détection d'anomalies, gestion des accréditations du personnel et suivi des bagages en temps réel."
        },
        connectivity: {
          title: "Connectivité Mondiale",
          description: "Intégration totale avec EUROCONTROL, SITA et principaux GDS mondiaux. Partage de données en temps réel avec compagnies aériennes, autorités de l'aviation civile et partenaires handling. APIs ouvertes pour intégration avec systèmes externes."
        }
      },
      uptime: "Disponibilité garantie"
    },
    
    // Coverage Section
    coverage: {
      overline: "COUVERTURE",
      title: "9 Îles, 9 Aéroports, 1 Système",
      description: "Couverture complète de tout l'archipel des Açores, garantissant connectivité et efficacité sur chaque île.",
      location: "Archipel des Açores, Portugal"
    },
    
    // Contact Section
    contact: {
      overline: "CONTACT",
      title: "Prêt à Transformer vos Opérations?",
      description: "Contactez-nous pour planifier une démonstration personnalisée et découvrir comment AzorPort peut révolutionner la gestion aéroportuaire dans votre organisation.",
      email: "Email",
      location: "Localisation",
      locationValue: "Vila do Corvo, Açores, Portugal",
      form: {
        title: "Demander une Démonstration",
        name: "Nom",
        namePlaceholder: "Votre nom",
        emailLabel: "Email",
        emailPlaceholder: "email@exemple.com",
        company: "Entreprise",
        companyPlaceholder: "Nom de l'entreprise",
        message: "Message",
        messagePlaceholder: "Comment pouvons-nous vous aider?",
        submit: "Envoyer le Message",
        submitting: "Envoi en cours..."
      },
      toast: {
        success: "Message envoyé avec succès!",
        successDescription: "Nous vous contacterons bientôt."
      }
    },
    
    // Footer
    footer: {
      description: "Plateforme de Gestion de l'Aviation pour les Açores. Connecter les îles, optimiser les opérations.",
      navigation: "Navigation",
      airports: "Aéroports",
      copyright: "© 2026 AzorPort | Aviation Management Platform",
      createdBy: "Créé par Diogo Ribeiro"
    },
    
    // Beta Banner
    beta: {
      badge: "BÊTA",
      banner: "Plateforme en phase Bêta — en développement constant et amélioration continue."
    }
  },

  de: {
    // Navigation
    nav: {
      about: "Über uns",
      platform: "Plattform",
      coverage: "Abdeckung",
      roadmap: "Roadmap",
      requestDemo: "Zur Plattform"
    },
    
    // Roadmap Page
    roadmap: {
      overline: "ENTWICKLUNG",
      title: "Roadmap & Changelog",
      subtitle: "Verfolgen Sie den Entwicklungsfortschritt der AzorPort-Plattform",
      backToHome: "Zurück zur Startseite",
      sections: {
        completed: "Abgeschlossen",
        inProgress: "In Entwicklung",
        planned: "Geplant"
      },
      phases: {
        phase1: {
          title: "Phase 1 — Grundlage",
          status: "completed",
          items: [
            "Authentifizierungssystem und Benutzerverwaltung",
            "Haupt-Dashboard mit Betriebsübersicht",
            "MongoDB-Datenbankintegration",
            "Responsive Oberfläche für Desktop und Mobile"
          ]
        },
        phase2: {
          title: "Phase 2 — Kernbetrieb",
          status: "inProgress",
          items: [
            "Echtzeit-Flugüberwachung",
            "Flughafen-Slot-Verwaltungssystem",
            "Automatische Warnungen und Benachrichtigungen",
            "Grundlegende Betriebsberichte"
          ]
        },
        phase3: {
          title: "Phase 3 — Erweiterte Integration",
          status: "planned",
          items: [
            "EUROCONTROL-Integration",
            "Öffentliche API für Partner",
            "Wettervorhersagesystem",
            "Prädiktives Wartungsmodul"
          ]
        },
        phase4: {
          title: "Phase 4 — Erweiterung",
          status: "planned",
          items: [
            "Native mobile Anwendung",
            "Buchungssystem-Integration",
            "Erweiterte KI-gestützte Analysen",
            "Multi-Tenant-Unterstützung"
          ]
        }
      },
      changelog: {
        title: "Aktuelles Changelog",
        entries: [
          { version: "0.3.0", date: "Dez 2025", changes: "Mehrsprachige Landingpage, Kontaktformular mit E-Mails" },
          { version: "0.2.0", date: "Nov 2025", changes: "Operations-Dashboard, grundlegendes Warnsystem" },
          { version: "0.1.0", date: "Okt 2025", changes: "Erstveröffentlichung der Beta-Version" }
        ]
      }
    },

    // Hero Section
    hero: {
      overline: "UNTERNEHMENSPLATTFORM",
      title: "Präzisions-Luftfahrtmanagement für die Azoren",
      description: "Eine zentralisierte Plattform, die den Betrieb von 9 Flughäfen im Azoren-Archipel verbindet und optimiert und dabei Effizienz und Sicherheit bei jedem Flug gewährleistet.",
      ctaPrimary: "Zur Plattform",
      ctaSecondary: "Funktionen Entdecken",
      stats: {
        airports: "Flughäfen",
        monitoring: "Überwachung",
        integration: "Integration"
      }
    },
    
    // About Section
    about: {
      overline: "ÜBER AZORPORT",
      title: "Den Archipel durch Innovation Verbinden",
      paragraph1: "AzorPort entstand aus der Notwendigkeit, das Flughafenmanagement auf den Azoren zu vereinheitlichen und zu modernisieren. Mit 9 Inseln und 9 Flughäfen erforderte die Herausforderung, koordinierte und effiziente Abläufe aufrechtzuerhalten, eine entsprechende Lösung.",
      paragraph2: "Unsere Plattform zentralisiert alle Abläufe, von der Flugsicherung über das Wartungsmanagement bis hin zur Koordination von Personal und Ground-Handling-Logistik.",
      paragraph3: "Mit modernster Technologie und einem engagierten Team stellen wir sicher, dass jeder Flug, der auf den Azoren landet oder startet, von einem robusten, sicheren System unterstützt wird, das für die Zukunft der Luftfahrt bereit ist.",
      founded: "Gründung",
      islandsServed: "Bediente Inseln",
      platformLabel: "Plattform"
    },
    
    // Features Section
    features: {
      overline: "PLATTFORM",
      title: "Weltklasse-Funktionen",
      description: "Eine komplette Suite von Werkzeugen für modernes und effizientes Flughafenmanagement.",
      items: {
        radar: {
          title: "Echtzeit-Überwachung",
          description: "Integriertes Radarsystem zur Verfolgung aller Flüge im azorischen Luftraum. Visualisieren Sie Flugzeugpositionen, Wetterbedingungen, Näherungsalarme und Telemetriedaten in Echtzeit. Interaktives Dashboard mit Filtern nach Flughafen, Fluggesellschaft und Flugzeugtyp."
        },
        traffic: {
          title: "Flugverkehrsmanagement",
          description: "Intelligente Koordination des azorischen Luftraums mit Slot-Management, Anflug- und Abflugsequenzierung sowie integrierter Kommunikation zwischen Kontrolltürmen. Automatische Routenoptimierung zur Minimierung von Verspätungen und Treibstoffverbrauch."
        },
        maintenance: {
          title: "Flottenwartung",
          description: "Vollständiges Lebenszyklusmanagement für Flugzeuge mit Inspektionskalender, Wartungshistorie, Teilekontrolle und Zertifizierungen. Automatische Warnungen für obligatorische Überprüfungen und Integration mit Herstellern für technische Updates."
        },
        operations: {
          title: "24/7 Betrieb",
          description: "Betriebszentrale mit kontinuierlicher Überwachung aller Flughäfen. Verwaltung von Ground-Handling-Teams, Treibstoffkoordination, Catering und Gepäck. Dedizierter technischer Support rund um die Uhr mit Reaktionszeit unter 15 Minuten."
        },
        security: {
          title: "Erweiterte Sicherheit",
          description: "EASA- und ICAO-zertifizierte Sicherheitsprotokolle. Biometrisches Zugangskontrollsystem, KI-gestützte Videoüberwachung zur Anomalieerkennung, Verwaltung von Personalausweisen und Echtzeit-Gepäckverfolgung."
        },
        connectivity: {
          title: "Globale Konnektivität",
          description: "Vollständige Integration mit EUROCONTROL, SITA und führenden globalen GDS-Systemen. Echtzeit-Datenaustausch mit Fluggesellschaften, Zivilluftfahrtbehörden und Handling-Partnern. Offene APIs für die Integration externer Systeme."
        }
      },
      uptime: "Garantierte Verfügbarkeit"
    },
    
    // Coverage Section
    coverage: {
      overline: "ABDECKUNG",
      title: "9 Inseln, 9 Flughäfen, 1 System",
      description: "Vollständige Abdeckung des gesamten Azoren-Archipels, die Konnektivität und Effizienz auf jeder Insel gewährleistet.",
      location: "Azoren-Archipel, Portugal"
    },
    
    // Contact Section
    contact: {
      overline: "KONTAKT",
      title: "Bereit, Ihre Abläufe zu Transformieren?",
      description: "Kontaktieren Sie uns, um eine personalisierte Demonstration zu vereinbaren und zu entdecken, wie AzorPort das Flughafenmanagement in Ihrer Organisation revolutionieren kann.",
      email: "E-Mail",
      location: "Standort",
      locationValue: "Vila do Corvo, Azoren, Portugal",
      form: {
        title: "Demo Anfordern",
        name: "Name",
        namePlaceholder: "Ihr Name",
        emailLabel: "E-Mail",
        emailPlaceholder: "email@beispiel.com",
        company: "Unternehmen",
        companyPlaceholder: "Unternehmensname",
        message: "Nachricht",
        messagePlaceholder: "Wie können wir helfen?",
        submit: "Nachricht Senden",
        submitting: "Wird gesendet..."
      },
      toast: {
        success: "Nachricht erfolgreich gesendet!",
        successDescription: "Wir werden Sie in Kürze kontaktieren."
      }
    },
    
    // Footer
    footer: {
      description: "Luftfahrt-Management-Plattform für die Azoren. Inseln verbinden, Abläufe optimieren.",
      navigation: "Navigation",
      airports: "Flughäfen",
      copyright: "© 2026 AzorPort | Aviation Management Platform",
      createdBy: "Erstellt von Diogo Ribeiro"
    },
    
    // Beta Banner
    beta: {
      badge: "BETA",
      banner: "Plattform in der Beta-Phase — in ständiger Entwicklung und kontinuierlicher Verbesserung."
    }
  }
};

export const languageNames = {
  pt: "Português",
  en: "English",
  es: "Español",
  fr: "Français",
  de: "Deutsch"
};

export const languageFlags = {
  pt: "🇵🇹",
  en: "🇬🇧",
  es: "🇪🇸",
  fr: "🇫🇷",
  de: "🇩🇪"
};

export default translations;
